import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { urls } from '../constants';

import SepaH from './sepaH';

// font awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBills } from '@fortawesome/free-solid-svg-icons';

const Tarifs = () => {    
    // store tarifs in state
    const[tarifs, setTarifs] = useState({});

    // to know if tarifs are loaded
    const[tarifsLoaded, setTarifsLoaded] = useState(false);

    // use effect hook to load tarifs
    useEffect(() => {
        axios.get(urls.api_url+'tarifs')
        .then((response) => {            
            if(response.status === 200) {
                setTarifs(response.data[0]);
                setTarifsLoaded(true);
            }
        });
    }, []);

    return (
        <div>
            {
                tarifsLoaded ?
                    <div className="content">
                        <h2><FontAwesomeIcon icon={faMoneyBills} />Tarifs</h2>
                        <SepaH />
                        <div className='content-text' dangerouslySetInnerHTML={{__html: tarifs.contenu}}></div>
                        <p className="groupes"><sup>*</sup> Groupes : <Link to="/contact">nous contacter</Link></p>
                    </div>
                :
                    <div>Chargement</div>
            }
        </div>
    );
};

export default Tarifs;